export interface ClientResultEnvelopeLike<T> {
  code: number;
  message?: string;
  data: T;
}

function isClientResultEnvelopeLike<T>(payload: unknown): payload is ClientResultEnvelopeLike<T> {
  return Boolean(payload && typeof payload === 'object' && 'code' in payload && 'data' in payload);
}

export function getClientPayload<T>(payload: T | ClientResultEnvelopeLike<T>): T {
  return isClientResultEnvelopeLike<T>(payload) ? payload.data : payload;
}

export function getClientPayloadArray<T>(
  payload: T[] | ClientResultEnvelopeLike<T[]> | null | undefined
): T[] {
  const resolved = payload == null ? [] : getClientPayload<T[]>(payload);
  return Array.isArray(resolved) ? resolved : [];
}

export function getClientPayloadRecords<T>(
  payload:
    | { records?: T[] | null }
    | ClientResultEnvelopeLike<{ records?: T[] | null }>
    | T[]
    | null
    | undefined
): T[] {
  if (payload == null) {
    return [];
  }
  const resolved = getClientPayload(payload);
  if (Array.isArray(resolved)) {
    return resolved;
  }
  return Array.isArray(resolved.records) ? resolved.records : [];
}
